import BaseModel from './BaseModel'
import pluralize from 'pluralize'
import { FETCH_PRODUCTS_SUCCESS } from '../redux/actions/products/products'
import React from 'react'

class Product extends BaseModel {
  static reducer (action, Product) {
    const products = action.products

    switch (action.type) {
      case FETCH_PRODUCTS_SUCCESS:
        let currentProducts = Product.all()
        if (action.reloadAll && currentProducts.count() > 0) {
          currentProducts.delete()
        }
        products.forEach(element => {
          Product.upsert(element)
        })
        break
    }
    return undefined
  }

  url () {
    let url
    if (this.type) {
      let type = pluralize(this.type.toLowerCase())
      if (type === 'plans') {
        type = 'series'
      }
      url = `/${type}/${this.slug}`
    }
    return url
  }

  firstCoachUrl () {
    if (this.coaches && this.coaches.length > 0) {
      const firstCoach = this.coaches[0]
      if (firstCoach.coachInfo && firstCoach.coachInfo.slug) {
        return `/instructors/${firstCoach.coachInfo.slug}`
      }
    }
  }

  coachLabel () {
    if (this.coaches) {
      return this.coaches.map((coach, idx) => {
        let coachName = `${coach.firstName} ${coach.lastName}`
        if (this.coaches.length > 1 && idx === this.coaches.length - 1) {
          coachName = ' & '.concat(coachName)
        }
        if (this.coaches.length > 0 && idx < this.coaches.length - 2) {
          coachName += ', '
        }
        if (coach.coachInfo) {
          return (
            <a
              key={coach.coachInfo.slug}
              href={'/instructors/' + coach.coachInfo.slug}
              data-refmarks-element='true'
            >
              {coachName}
            </a>
          )
        } else {
          return <span key={idx}>{coachName}</span>
        }
      })
    }
  }
}

Product.modelName = 'Product'
Product.apiPath = '/products'

export default Product
